"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCountry = exports.SET_COUNTRY = exports.COUNTRY = void 0;
exports.COUNTRY = '[Market]';
exports.SET_COUNTRY = `${exports.COUNTRY} SET`;
const setCountry = ({ country = '' }) => ({
    type: exports.SET_COUNTRY,
    payload: country,
    meta: { feature: exports.COUNTRY },
});
exports.setCountry = setCountry;
//# sourceMappingURL=country.js.map